import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { SubPage } from './pages/SubPage';
import { ProfilPage } from './pages/ProfilPage';
import { QualifikationenPage } from './pages/QualifikationenPage';
import { ArbeitsweisePage } from './pages/ArbeitsweisePage';
import { CoachingPage } from './pages/CoachingPage';
import { KarriereCoachingPage } from './pages/KarriereCoachingPage';
import { FuehrungsCoachingPage } from './pages/FuehrungsCoachingPage';
import { MentaleGesundheitPage } from './pages/MentaleGesundheitPage';
import { ManagementDiagnostikPage } from './pages/ManagementDiagnostikPage';
import { PotenzialanalysenPage } from './pages/PotenzialanalysenPage';
import { AssessmentCenterPage } from './pages/AssessmentCenterPage';
import { InterviewtrainingPage } from './pages/InterviewtrainingPage';
import { ChangeBeratungPage } from './pages/ChangeBeratungPage';
import { KonzeptionUmsetzungPage } from './pages/KonzeptionUmsetzungPage';
import { TeamentwicklungPage } from './pages/TeamentwicklungPage';
import { KontaktPage } from './pages/KontaktPage';
import { ImpressumPage } from './pages/ImpressumPage';
import { DatenschutzPage } from './pages/DatenschutzPage';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <div className="flex flex-col min-h-screen w-full font-sans" data-id="element-2">
        <Header data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<App data-id="element-7" />} data-id="element-6" />
            <Route path="/about" element={<div className="flex-grow" data-id="element-9">
                  <SubPage data-id="element-10" />
                </div>} data-id="element-8" />
            <Route path="/about/profil" element={<div className="flex-grow" data-id="element-12">
                  <ProfilPage data-id="element-13" />
                </div>} data-id="element-11" />
            <Route path="/about/qualifikationen" element={<div className="flex-grow" data-id="element-15">
                  <QualifikationenPage data-id="element-16" />
                </div>} data-id="element-14" />
            <Route path="/about/arbeitsweise" element={<div className="flex-grow" data-id="element-18">
                  <ArbeitsweisePage data-id="element-19" />
                </div>} data-id="element-17" />
            <Route path="/coaching" element={<div className="flex-grow" data-id="element-21">
                  <CoachingPage data-id="element-22" />
                </div>} data-id="element-20" />
            <Route path="/coaching/karriere" element={<div className="flex-grow" data-id="element-24">
                  <KarriereCoachingPage data-id="element-25" />
                </div>} data-id="element-23" />
            <Route path="/coaching/fuehrung" element={<div className="flex-grow" data-id="element-27">
                  <FuehrungsCoachingPage data-id="element-28" />
                </div>} data-id="element-26" />
            <Route path="/coaching/mentale-gesundheit" element={<div className="flex-grow" data-id="element-30">
                  <MentaleGesundheitPage data-id="element-31" />
                </div>} data-id="element-29" />
            <Route path="/management-diagnostik" element={<div className="flex-grow" data-id="element-33">
                  <ManagementDiagnostikPage data-id="element-34" />
                </div>} data-id="element-32" />
            <Route path="/management-diagnostik/potenzialanalysen" element={<div className="flex-grow" data-id="element-36">
                  <PotenzialanalysenPage data-id="element-37" />
                </div>} data-id="element-35" />
            <Route path="/management-diagnostik/assessment-center" element={<div className="flex-grow" data-id="element-39">
                  <AssessmentCenterPage data-id="element-40" />
                </div>} data-id="element-38" />
            <Route path="/management-diagnostik/interviewtraining" element={<div className="flex-grow" data-id="element-42">
                  <InterviewtrainingPage data-id="element-43" />
                </div>} data-id="element-41" />
            <Route path="/change-beratung" element={<div className="flex-grow" data-id="element-45">
                  <ChangeBeratungPage data-id="element-46" />
                </div>} data-id="element-44" />
            <Route path="/change-beratung/konzeption-umsetzung" element={<div className="flex-grow" data-id="element-48">
                  <KonzeptionUmsetzungPage data-id="element-49" />
                </div>} data-id="element-47" />
            <Route path="/change-beratung/teamentwicklung" element={<div className="flex-grow" data-id="element-51">
                  <TeamentwicklungPage data-id="element-52" />
                </div>} data-id="element-50" />
            <Route path="/kontakt" element={<div className="flex-grow" data-id="element-54">
                  <KontaktPage data-id="element-55" />
                </div>} data-id="element-53" />
            <Route path="/impressum" element={<div className="flex-grow" data-id="element-57">
                  <ImpressumPage data-id="element-58" />
                </div>} data-id="element-56" />
            <Route path="/datenschutz" element={<div className="flex-grow" data-id="element-60">
                  <DatenschutzPage data-id="element-61" />
                </div>} data-id="element-59" />
          </Routes>
        </main>
        <Footer data-id="element-62" />
      </div>
    </BrowserRouter>;
}